import { ChangeDetectionStrategy, Component, input, InputSignal, output, OutputEmitterRef } from '@angular/core';
import { IconComponent } from '@libs/components/icons';
import { ConfigurableBundleSummaryVisibleSections } from '../api';

@Component({
  selector: 'ui-configurable-bundle-form-bottom-bar',
  imports: [IconComponent],
  templateUrl: './configurable-bundle-form-bottom-bar.component.html',
  styleUrl: './configurable-bundle-form-bottom-bar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfigurableBundleFormBottomBarComponent {
  public addToCartDisabled: InputSignal<boolean> = input.required();
  public isAddToCartLoading: InputSignal<boolean> = input(false);

  public openSideSheet: OutputEmitterRef<ConfigurableBundleSummaryVisibleSections> = output();
  public addToCart: OutputEmitterRef<void> = output();
}
